document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".content-element-group > h2[id], .content-element-group > h3[id]")
    .forEach(function(heading) {
      const id = heading.getAttribute("id");
      if (!id) return;

      const url = window.location.origin + window.location.pathname + "#" + id;

      const link = document.createElement("a");
      link.href = url;
      link.innerHTML = "<span>Link kopieren</span>";
      link.style.cursor = "pointer";

      link.addEventListener("click", function(e) {
        e.preventDefault();
        navigator.clipboard.writeText(url).then(() => {
          // Text ändern
          const oldText = link.innerHTML;
          link.innerHTML = "<span>Link kopiert</span>";
          setTimeout(() => {
            link.innerHTML = oldText;
          }, 2000);

          // Hash setzen, damit :target greift und Browser scrollt
          location.hash = id;
        }).catch(err => {
          console.error('Fehler beim Kopieren:', err);
        });
      });

      heading.appendChild(link);
    });
});
